<div class="lfd-right-panel" [ngClass]="rightPanelStatus ? 'open' : 'close'">
    <div class="selector-toggle">
        <span (click)="changeTheRightPanelStatus()">
            <img src="assets/right.png" class="img-fluid" style="max-width: 25px;"/></span>
    </div>
    <div class="rp_inner">
        <h4 *ngIf="passwordHistoryDate" style="font-weight: 500;">Password History</h4>
        <small *ngIf="passwordHistoryDate">Last password changed : <b>{{ passwordHistoryDate | date: "mediumDate" }} {{ passwordHistoryDate | date: "shortTime" }}</b></small>
        <hr/>
        <h4 *ngIf="!showTokenBar" style="font-weight: 500;">Settings</h4>
        <p *ngIf="!showTokenBar">Change password for downloadable zip files</p>
        <form class="form" [formGroup]="passwordForm" *ngIf="!showTokenBar" autocomplete="off">
            <label class="lbl">Password</label>
            <div class="form-label-group">
                <input type="text" name="fakepasswordrightremembered" formControlName="password" class="form-control" id="password" (input)="changeType()" (change)="changeType()"
                placeholder="Enter Password" autocomplete="off" />
                <label for="password">Enter Password</label>
            </div>

            <label class="lbl">Re Enter Password</label>
            <div class="form-label-group">
                <input type="text" name="fakerepasswordremembered" formControlName="repassword" class="form-control" id="repassword" (input)="changeTypeRe()" (change)="changeTypeRe()"
                placeholder="Enter Password" autocomplete="off" />
                <label for="repassword">Re-enter Password</label>
            </div>

            <div class="alert alert-danger" *ngIf="((errorMessage && errorMessage.length) || showPassErr)">
                <span *ngIf="showPassErr">*{{showPassErr}}<br></span>
                <span *ngFor="let message of errorMessage"> *{{message}}<br></span>
            </div>

            <button class="btn btn-primary" (click)="ChangePassword()" [disabled]="!passwordForm.valid || buttonDisabled">
            <ngx-bootstrap-spinner name="passwordSpinner" bdColor = "rgba(0, 0, 0, 0.8)" size = "small" color = "#d91d1d" type = "border" isButtonSpinner = "true" autoDisableButton = "true" loadingText = "">
            </ngx-bootstrap-spinner>
            Change Password
            </button>
            <br><br>
            <div class="alert alert-success" *ngIf="passwordReqSentMsg">{{passwordReqSentMsg}}</div>

        </form>

        <form class="form" [formGroup]="validateCodeForm" *ngIf="showTokenBar" autocomplete="off">
            <h4  style="font-weight: 500;">VERIFICATION TOKEN</h4>
            <p>Enter the verification token sent on the administrator's email</p>
            <!-- <button (click)="startTimer()">click</button> -->
            

            <label class="lbl">Enter Token</label>
            <div class="form-label-group">
                <input type="text" name="token" id="token" class="form-control" placeholder="token" formControlName="code" autocomplete="off" autofocus/>
                <label for="code">Token</label>
            </div>
            <button class="btn btn-primary" (click)="ValidateToken()" [disabled]="validateCodeForm.invalid || buttonDisabled">
                <ngx-bootstrap-spinner name="validateTokenSpinner" bdColor = "rgba(0, 0, 0, 0.8)" size = "small" color = "#d91d1d" type = "border" isButtonSpinner = "true" autoDisableButton = "true" loadingText = "">
                </ngx-bootstrap-spinner>
                Verify Token
            </button>
            <span class="float-right" style="margin-top: 8px;">{{counter | formatTime}}</span>
            <br><br>
                <div class="alert alert-success" *ngIf="msgValidated">{{msgValidated}}</div>
                <div class="alert alert-danger" *ngIf="showValidationError">{{showValidationError}}</div>
                <div class="alert alert-danger" *ngIf="errorMessageValidToken">Incorrect token</div>

                
        </form>
        
    </div>
</div>
